import React from "react";
import { Modal, Button } from "react-bootstrap";

const ReviewModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      size="lg"
      className="exam-modal"
    >
      <Modal.Header className="modal-bg text-white">
        <Modal.Title>Review Instructions</Modal.Title>
      </Modal.Header>

      <Modal.Body className="d-flex align-items-start gap-3">
      <i className="bi bi-question-circle fs-2 modal-icon"></i>
        <p>
            Below is a summary of your answers. You can review your questions in three (3) different ways. <br />

            The buttons in the lower right-hand corner correspond to these choices: <br />

            1. Review all of your questions and answers. <br />
            2. Review questions that are incomplete. <br />
            3. Review questions that are flagged for review. (Click the 'flag' icon to change the flag for review status.) <br />

            You may also click on a question number to link directly to its location in the exam.
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button
          onClick={()=>onClose()}
          className="px-4 py-2 modal-btn"
        >
          Close
        </Button>
        
      </Modal.Footer>
    </Modal>
  );
};

export default ReviewModal;
